import { XyoWorldEntitySettingsClient } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

const Context = createContext<XyoWorldEntitySettingsClient | undefined>(undefined)

export default Context
